module.exports = __webpack_public_path__ + "static/media/Other2.1fbe891e.svg";